module.exports = __webpack_public_path__ + "img/png2.ad541303.jpg";